import { Section, SHELL } from '@/components/base/Frame';
import Link from '@/components/base/TransitionLink';
import { brand, navLinks } from '@/mocks/home';
import HeroRibbon from './HeroRibbon';

export default function FinalCta() {
  return (
    <Section id="contact" groundedBottom className="overflow-hidden">
      <div className={`relative ${SHELL} flex flex-1`}>
        {/* Screen frame: everything is clipped inside the two rails and the section bounds */}
        <div data-cursor-light="true" className="relative flex w-full flex-col overflow-hidden bg-[#0F62FE]">
          <HeroRibbon tone="onBlue" />

          <div className="relative flex flex-1 flex-col justify-center px-6 py-12 md:px-8 lg:py-8">
            <div className="max-w-[38rem]">
              <p className="font-label text-xs uppercase tracking-[0.18em] text-background-50/80">
                <span className="text-background-50">06</span>
                <span className="mx-2 text-background-50/50">/</span>
                Contact
              </p>
              <h2 className="reveal-up mt-6 text-4xl font-light leading-[1.06] tracking-[-0.02em] text-background-50 lg:text-[52px]">
                Bring us one workflow.
              </h2>
              <p className="mt-6 max-w-[30rem] text-base font-light leading-relaxed text-background-50/85 md:text-lg">
                We&rsquo;ll help you identify where AI can create practical leverage without rebuilding everything around it.
              </p>
              <Link
                to="/contact"
                className="group cursor-target mt-10 flex w-full cursor-pointer items-center justify-between whitespace-nowrap bg-background-50 px-6 py-4 text-sm text-primary-600 transition-colors duration-200 hover:bg-background-100 sm:inline-flex sm:w-auto sm:gap-16"
              >
                Discuss a Workflow
                <span className="cta-arrow">&rarr;</span>
              </Link>
            </div>
          </div>

          <footer className="relative flex flex-col gap-6 px-6 pb-8 md:flex-row md:items-end md:justify-between md:px-8">
            <div>
              <a href="#top" className="cursor-target cursor-pointer text-lg text-background-50">
                {brand.name}
                <span className="ml-1 font-light text-background-50/60">/</span>
              </a>
              <p className="mt-2 text-sm text-background-50/80">{brand.descriptor}</p>
              <p className="mt-4 font-label text-xs text-background-50/75">&copy; 2026 {brand.name}. All rights reserved.</p>
            </div>
            <nav className="flex flex-wrap gap-x-8 gap-y-2">
              {navLinks.map((l) => (
                <a key={l.href} href={l.href} className="link-line cursor-target cursor-pointer whitespace-nowrap text-sm text-background-50/85 hover:text-background-50">
                  {l.label}
                </a>
              ))}
              {brand.email && (
                <a href={`mailto:${brand.email}`} className="link-line cursor-target cursor-pointer whitespace-nowrap text-sm text-background-50/85 hover:text-background-50">
                  {brand.email}
                </a>
              )}
              {brand.linkedin && (
                <a href={brand.linkedin} target="_blank" rel="noopener noreferrer" className="link-line cursor-target cursor-pointer whitespace-nowrap text-sm text-background-50/85 hover:text-background-50">
                  LinkedIn
                </a>
              )}
            </nav>
          </footer>
        </div>
      </div>
    </Section>
  );
}